import React from 'react';
import { Link } from 'react-router-dom';
import './Gallery.css';
import PRODUCTS, { getProductHero } from '../utils/shopData';
import { playNextNote, HOVER_COLORS } from '../utils/hoverMelody';
import ThumbnailPlaceholder from '../utils/ThumbnailPlaceholder';

/* The shop is the work grid with a price on it: same tiles, same hover, same
   colours, so a shirt sits in the archive rather than in a separate store. */
export default function Shop() {
  return (
    <div>
      <div className="home-container">
        <div className="body-text">&nbsp;</div>

        <div className="grid-container">
          {PRODUCTS.map((p, i) => {
            const colour = HOVER_COLORS[(i + 1) % HOVER_COLORS.length];
            const hero = getProductHero(p);
            return (
              <div key={p.slug} className="grid-item">
                <Link
                  to={`/shop/${p.slug}`}
                  className="tile-link"
                  style={{ '--hover-color': colour }}
                  onMouseEnter={playNextNote}
                >
                  <ThumbnailPlaceholder />
                  {hero && <img src={hero} alt={p.title} loading="lazy" />}
                  <span className="tile-hover" aria-hidden="true">
                    <span className="tile-hover-title">
                      <span className="tile-hover-mark">
                        {p.title}
                        {p.soldOut ? ' — Sold out' : p.price ? ` — ${p.price}` : ''}
                      </span>
                    </span>
                  </span>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
